import { Box } from '@mui/material'
import { isDiagnosisEntryComplete } from 'components/cattles/checkupPage/utils/checkupValidation'
import { ICheckupList, IDiagnosisBlock } from 'models'
import { Dispatch, SetStateAction, useEffect } from 'react'
import { COLORS } from 'styles/colors'
import { CardStandart } from 'ui/CardStandart'
import SwitchiOS from 'ui/SwitchiOS'
import { TypographyHeaderSecondary } from 'ui/typography/TypographyHeaderSecondary'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

type DisposeRecommendedBlockProps = {
	disposeRecommended: boolean
	setCheckupInfo: Dispatch<SetStateAction<ICheckupList>>
	diagnosisInfo: IDiagnosisBlock[]
	onValidationErrorToggle: Dispatch<SetStateAction<boolean>>
}

const DisposeRecommendedBlock = (props: DisposeRecommendedBlockProps) => {
	const {
		disposeRecommended,
		setCheckupInfo,
		diagnosisInfo,
		onValidationErrorToggle,
	} = props

	const hasCompleteDiagnosis = diagnosisInfo.some(isDiagnosisEntryComplete)
	const showDisposeError = disposeRecommended && !hasCompleteDiagnosis

	useEffect(() => {
		onValidationErrorToggle(showDisposeError)
	}, [onValidationErrorToggle, showDisposeError])

	const toggleSwitch = () => {
		setCheckupInfo(prev => ({
			...prev,
			dispose_recommended: !prev.dispose_recommended,
		}))
	}

	return (
		<CardStandart sx={{ padding: '24px' }}>
			<Box
				display={'flex'}
				flexDirection={'row'}
				width={'100%'}
				alignItems={'flex-start'}
				gap={'40px'}
			>
				<Box width={'240px'}>
					<TypographyHeaderSecondary
						sx={{ color: disposeRecommended ? COLORS.error : COLORS.black }}
					>
						Рекомендовать
						<br />
						выбытие
					</TypographyHeaderSecondary>
				</Box>
				<Box>
					<SwitchiOS
						checked={disposeRecommended}
						background={COLORS.error}
						onClick={toggleSwitch}
					/>
					{showDisposeError && (
						<TypographySecondary
							sx={{ color: COLORS.error, marginTop: '16px' }}
						>
							Выберите больные копыта и укажите диагноз
						</TypographySecondary>
					)}
				</Box>
			</Box>
		</CardStandart>
	)
}

export default DisposeRecommendedBlock
